import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import React, { useState } from 'react'
import MRejectAssign from 'tennders-transactions/modal/MRejectAssign'
import { apiPost } from 'tennders-stracture/libs/api'
import useSocket from 'tennders-common/hooks/useSocket'
import { QC_PANEL_ACCEPT_REJECT_TRANSACTION } from 'tennders-stracture/libs/permissions'
import RequiresPermission from 'tennders-auth/components/RequiresPermission'
import { useToast } from 'tennders-common/hooks/useToast'
import GHref from 'tennders-market/common/components/element/GHref'
import { RowPropsTransaction } from 'tennders-market/bin/components/row/RowProps'
import useQcStore from 'tennders-market/qa/stores/useQcStore'
import useCompanyDirModal from 'tennders-company/details/hooks/useCompanyDirModal'
import QcTransactionHoldModal from 'tennders-market/qa/modals/QcTransactionHoldModal'

const selector = (state) => [
  state.deleteQC
]
const RowQAApproveAction = ({ transaction, closeTransaction, isOpenToQC = true } : RowPropsTransaction) => {
  const { t } = useTranslation()
  const [deleteQC] = useQcStore(selector)
  const { toastSuccess } = useToast()
  const { setRefresh } = useSocket()
  const [submitting, setsubmitting] = useState(false)
  const [approving, setapproving] = useState(false)
  const [rejecting, setrejecting] = useState(false)

  const { content: holdModalContent, openModal: openHoldModal } = useCompanyDirModal({
    Component: QcTransactionHoldModal,
    refreshFunction: () => setRefresh('all'),
    company: transaction
  })

  const approve = async () => {
    if (approving) {
      const url = `transactions/${transaction?.id}/approve`
      setsubmitting(true)
      const response = await apiPost(url, {})
      toastSuccess(t('transaction:assignApproved'))
      deleteQC(transaction?.id)
      setapproving(false)
      setRefresh('all')
      if (response.id) {
        setRefresh('all')
      }
      setsubmitting(false)
      if (closeTransaction) {
        closeTransaction()
      }
    } else {
      setapproving(true)
    }
  }

  const cancel = () => {
    if (approving) {
      setapproving(false)
    } else {
      setrejecting(true)
    }
  }

  return (
    <div className="tennders-blt-cell ">
      <div className="d-flex row align-center justify-end">
        {/* Approve */}
        <RequiresPermission
          requiredPermissions={QC_PANEL_ACCEPT_REJECT_TRANSACTION}
          fallbackComponent={(
            <GHref
              tip="You dont have permission"
              className="btn standard-btn medium mb-8"
            >
              <Trans i18nKey="tableRow:approve" />
            </GHref>
          )}
        >
          <GHref
            submitting={submitting}
            onClick={!submitting && approve}
            disabled={isOpenToQC === false || submitting}
            className="btn standard-btn medium mb-8"
          >
            {approving
              ? <Trans i18nKey="tHead:confirmApprove" />
              : <Trans i18nKey="tableRow:approve" />}
          </GHref>
        </RequiresPermission>
        {/* --- Approve --- */}
        {/* Hold */}
        {!transaction?.onHold?.status && (
          <RequiresPermission
            requiredPermissions={QC_PANEL_ACCEPT_REJECT_TRANSACTION}
            fallbackComponent={(
              <GHref
                tip="You dont have permission"
                className="btn-border standard-btn ml-8 mb-8 medium"
              >
                <Trans i18nKey="tableRow:hold" />
              </GHref>
            )}
          >
            <GHref
              onClick={() => openHoldModal(transaction.id, null)}
              disabled={isOpenToQC === false}
              className="btn-border standard-btn ml-8 mb-8 medium"
            >
              {t('tableRow:hold')}
            </GHref>
          </RequiresPermission>
        )}
        {/* --- Hold --- */}
        {/* Reject */}
        <RequiresPermission
          requiredPermissions={QC_PANEL_ACCEPT_REJECT_TRANSACTION}
          fallbackComponent={(
            <GHref
              disabled={isOpenToQC === false}
              tip="You dont have permission"
              className="btn btn-link medium ml-8 mb-8"
            >
              <Trans i18nKey="tableRow:reject" />
            </GHref>
          )}
        >
          <GHref
            onClick={cancel}
            disabled={isOpenToQC === false}
            className="btn btn-link medium ml-8 mb-8"
          >
            {approving ? <Trans i18nKey="common:back" />
              : <Trans i18nKey="tableRow:reject" />}
          </GHref>
        </RequiresPermission>
        {/* --- Reject --- */}
        {transaction?.onHold?.status && <div className="text-10"><span className="font-bold mr-2">{t('qc:on_hold')}</span>({transaction?.onHold?.reason})</div>}
        <MRejectAssign
          size={400}
          isOpen={rejecting}
          close={() => setrejecting(false)}
          transaction={transaction}
          closeTransaction={closeTransaction}
        />
        {holdModalContent}
      </div>
    </div>
  )
}

export default RowQAApproveAction
